<template>
  <div class="page page-with-bg">
    <div class="page-form-wrap">
      <div class="page-form-header">
        <h1>Welcome!</h1>
        <div class="description">
          <p>
            We are working closely with your healthcare professional to  <br />
            provide you clear assessments of your personal health risks.
          </p>
          <p>
            Currently we are offering diabetic risk assessments but will <br />
            have a series of different tests available soon.
          </p>
        </div>
        <div class="page-form-content">
          <div class="card-wrap">
            <b-card class="card-clickable" @click="viewReports">
              <svg-icon class="card-icon" name="viewreports" />
              <div class="card-title">View Reports</div>
            </b-card>
            <b-card class="card-clickable" @click="manageProfile">
              <svg-icon class="card-icon" name="manageprofile" />
              <div class="card-title">Manage Profile</div>
            </b-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {};
    },

    methods: {
      manageProfile() {
        this.$router.push("profile/edit");
      },

      viewReports() {
        this.$router.push("reports");
      }
    }
  };
</script>

<style scoped lang="scss">
  @import '@/styles/_mixins';

  .page {
    @include retina('/png/plant.png');
  }
</style>